const initialState = {
  data: undefined
}

export default function reducer(state = initialState, _action) {
  return state
}
